import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["dispatchModal", "byFieldModal", "allFieldModal", "statsTable", "toggleButton"];

  toggleStats() {
    if (this.statsTableTarget.classList.contains('is-hidden')) {
      this.statsTableTarget.classList.remove("is-hidden");
      this.toggleButtonTarget.innerHTML = "Voir moins ⇡⇡⇡⇡"
    } else {
      this.statsTableTarget.classList.add("is-hidden");
      this.toggleButtonTarget.innerHTML =  "Voir plus de détails ⇣⇣⇣⇣"
    }
  }

  semestreChoice() {
    this.dispatchModalTarget.classList.add("is-active");
  }

  byFieldChoice() {
    this.byFieldModalTarget.classList.add("is-active");
  }

  allFieldChoice() {
    this.allFieldModalTarget.classList.add("is-active");
  }

  destroy() {
    this.dispatchModalTarget.classList.remove("is-active");
    this.byFieldModalTarget.classList.remove("is-active");
    this.allFieldModalTarget.classList.remove("is-active");

    const submitButton = document.getElementById("modal-submit-button");

    if (submitButton) {
      submitButton.removeAttribute('disabled');
    }
  }

  resetFormAfterSubmit(event) {
    const form = event.target
    const submitButton = form.querySelector("input[type='submit']")

    event.preventDefault()

    form.submit()

    if (submitButton) {
      submitButton.disabled = true
    }

    setTimeout(() => {
      form.reset()
      if (submitButton) {
        submitButton.disabled = false
      }
    }, 2000)
  }
}
